import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactNode } from 'react';

import { config } from '@/config';

export const queryCache = new QueryCache({
  onError: (error, query) => {
    if (query.meta?.suppressErrorLog) {
      return;
    }
    console.error({ key: query.queryKey, error: error.message });
  },
});

// Create and export the queryClient instance
export const queryClient = new QueryClient({
  queryCache,
  defaultOptions: {
    queries: {
      refetchOnMount: false,
      refetchOnReconnect: true,
      retry: config.IS_DEVELOPMENT ? false : 3,
    },
  },
});

export function ReactQueryProvider({ children }: { children: ReactNode }) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
